import fetTypes from './fetTypes/hi.js';
import transistorTech from './transistorTech/hi.js';

export default {
  fetTypes,
  transistorTech,
  meta: {
    code: 'hi',
    name: 'Hindi',
    nativeName: 'हिन्दी',
    dir: 'ltr',
    flag: '🇮🇳'
  },
  header: {
    title: 'अर्धचालक भौतिकी सीखना',
    subtitle: 'शैक्षिक सिम्युलेटर - विज्ञान और उन्नत भौतिकी का प्रसार',
    visitors: 'आगंतुक'
  },
  footer: {
    model: 'भौतिक मॉडल: पैराबोलिक बैंड सन्निकटन, फ्रीज़-आउट तापमान से ऊपर डोपेंट्स का पूर्ण आयनन, गैर-अपक्षयी अर्धचालक। Eg(T) के लिए वर्षनी सूत्र। SI नियतांक।',
    nonprofit: 'गैर-लाभकारी परियोजना',
    partOf: 'का हिस्सा',
    network: 'Basicão da Eletrônica साइटों का नेटवर्क',
    copyright: 'शैक्षिक CC BY-SA 4.0 · React + SVG + KaTeX'
  },
  menu: {
    categories: {
      learning: '📚 अध्ययन',
      fundamentals: '🔬 मूल सिद्धांत',
      bandStructure: '⚛️ बैंड संरचना',
      quantumStatistics: '📊 क्वांटम सांख्यिकी',
      devices: '⚡ युक्तियाँ',
      reference: '📐 संदर्भ'
    },
    items: {
      objectives: '🎯 अध्ययन रोडमैप',
      conceptsQ: '📖 प्रश्न अवधारणाएँ',
      questions: '❓ प्रश्न',
      glossary: '📚 शब्दावली',
      overview: 'अवलोकन',
      lattice: 'क्रिस्टल जाली',
      'diamond-unit-cell': '💎 हीरा यूनिट सेल',
      'crystal-structures': '💎 क्रिस्टल संरचनाएँ',
      atomband: 'परमाणु → बैंड',
      quantumAtom: '⚛️ क्वांटम परमाणु मॉडल',
      allowed: 'अनुमत/निषिद्ध बैंड',
      kp: 'क्रोनिग-पेनी',
      mis: 'धातु × कुचालक × अर्धचालक',
      kspace: 'k-स्पेस (Si × GaAs)',
      effmass: 'प्रभावी द्रव्यमान',
      particles: 'इलेक्ट्रॉन × होल',
      fermi: 'फर्मी-डिराक और MB',
      'fermi-edu': '📊 फर्मी-डिराक शैक्षिक',
      dos: 'अवस्थाओं का घनत्व',
      'dos-edu': '📊 DOS शैक्षिक',
      arrhenius: 'n(T) अरहेनियस',
      junction: '⚡ PN संधि',
      transistorTech: '🔬 ट्रांजिस्टर प्रौद्योगिकियाँ',
      fetTypes: '🧪 FET ट्रांजिस्टर प्रकार',
      czochralski: '🔬 वृद्धि विधियाँ',
      perovskites: '☀️ 2D पेरोवस्काइट',
      exercises: '📝 अभ्यास',
      periodic: '⚛️ आवर्त सारणी',
      about: '👤 परिचय',
      'support-us': '💖 हमारा समर्थन करें',
      community: '🤝 GitHub पर योगदान दें',
      community_title: 'GitHub चर्चा फ़ोरम में शामिल हों — योगदान देने के लिए GitHub खाता आवश्यक है'
    },
    quantumAtom: '⚛️ क्वांटम परमाणु मॉडल'
  },
  quantumAtom: {
    title: 'क्वांटम परमाणु मॉडल',
    subtitle: 'क्वांटम यांत्रिकी के अनुसार परमाणु का आधुनिक दृष्टिकोण',
    alt: 'क्वांटम परमाणु मॉडल जिसमें नाभिक, इलेक्ट्रॉन बादल और कक्षक दिखाए गए हैं',
    sections: {
      nucleus: {
        title: 'परमाणु नाभिक',
        content: 'नाभिक में प्रोटॉन (धनात्मक आवेश) और न्यूट्रॉन (आवेशरहित) होते हैं, जो परमाणु के अधिकांश द्रव्यमान का प्रतिनिधित्व करते हैं। नाभिक के कण प्रबल नाभिकीय बल द्वारा एक साथ बंधे रहते हैं।'
      },
      electronCloud: {
        title: 'इलेक्ट्रॉन बादल',
        content: 'बोर मॉडल के विपरीत, इलेक्ट्रॉन निश्चित कक्षाओं का अनुसरण नहीं करते। उन्हें एक प्रायिकता बादल द्वारा वर्णित किया जाता है — वे क्षेत्र जहाँ इलेक्ट्रॉन मिलने की अधिक संभावना होती है। इस बादल को तरंग फलन ψ(r) द्वारा दर्शाया जाता है।'
      },
      orbitals: {
        title: 'परमाणु कक्षक',
        content: 'कक्षक अंतरिक्ष के वे क्षेत्र हैं जहाँ इलेक्ट्रॉन मिलने की उच्च प्रायिकता होती है। प्रत्येक कक्षक का एक विशिष्ट आकार होता है: s कक्षक गोलाकार होते हैं, p कक्षक डम्बल के आकार के, d कक्षक अधिक जटिल, इत्यादि। आकार क्वांटम संख्याओं द्वारा निर्धारित होता है।'
      },
      waveFunction: {
        title: 'तरंग फलन',
        content: 'इलेक्ट्रॉनों का गणितीय वर्णन तरंग फलनों ψ(x,y,z,t) द्वारा किया जाता है। तरंग फलन का वर्ग |ψ|² किसी दिए गए स्थान पर इलेक्ट्रॉन मिलने की प्रायिकता घनत्व को दर्शाता है। यह क्वांटम यांत्रिकी की बोर्न व्याख्या का आधार है।'
      },
      uncertainty: {
        title: 'अनिश्चितता का सिद्धांत',
        content: 'वर्नर हाइजेनबर्ग द्वारा प्रतिपादित, यह सिद्धांत बताता है कि किसी कण की स्थिति और संवेग को एक साथ मनचाही परिशुद्धता से जानना असंभव है। Δx·Δp ≥ ℏ/2। इसका अर्थ है कि हम स्थिति को जितनी अधिक परिशुद्धता से जानते हैं, संवेग के बारे में उतना ही कम जानते हैं, और इसके विपरीत।'
      }
    },
    comparison: {
      title: 'परमाणु मॉडलों का विकास',
      rutherford: {
        title: 'रदरफोर्ड मॉडल (1911)',
        items: [
          'परमाणु सौर मंडल जैसा: सघन नाभिक और परिक्रमा करते इलेक्ट्रॉन',
          'अल्फा कण प्रयोग के माध्यम से परमाणु नाभिक की खोज',
          'इलेक्ट्रॉन मनमानी कक्षाओं में (बिना क्वांटमीकरण)',
          'परमाणु की स्थिरता की व्याख्या नहीं करता (इलेक्ट्रॉनों को नाभिक में गिरना चाहिए था)',
          'प्रेक्षित परमाणु स्पेक्ट्रम के साथ असंगत'
        ]
      },
      bohr: {
        title: 'बोर मॉडल (1913)',
        items: [
          'इलेक्ट्रॉन निश्चित, क्वांटमीकृत वृत्ताकार कक्षाओं में',
          'बिना विकिरण के स्थिर कक्षाओं की परिकल्पना',
          'ऊर्जा का असतत स्तरों में क्वांटमीकरण',
          'हाइड्रोजन स्पेक्ट्रम की व्याख्या की, परंतु एक से अधिक इलेक्ट्रॉन वाले परमाणुओं की नहीं',
          'चिरसम्मत और क्वांटम भौतिकी का मिश्रण (अर्ध-चिरसम्मत)'
        ]
      },
      quantum: {
        title: 'क्वांटम मॉडल (1926-वर्तमान)',
        items: [
          'इलेक्ट्रॉन प्रायिकता बादल में',
          'स्थिति प्रायिकता वितरण द्वारा वर्णित',
          'क्वांटम संख्याओं (n, l, m, s) के माध्यम से क्वांटमीकरण',
          'सभी परमाणुओं और अणुओं की व्याख्या करता है',
          'अनिश्चितता सिद्धांत के अनुरूप'
        ]
      }
    }
  },
  controlPanel: {
    title: '⚙️ सिस्टम पैरामीटर'
  },
  controls: {
    material: 'पदार्थ',
    dopingType: 'डोपिंग प्रकार',
    intrinsic: 'अंतर्निहित',
    ntype: 'n-प्रकार (P)',
    ptype: 'p-प्रकार (B)',
    temperature: 'तापमान',
    donorConcentration: 'N_D (फॉस्फोरस)',
    acceptorConcentration: 'N_A (बोरॉन)',
    manualFermi: 'E_F मैन्युअल सेट करें (eV)'
  },
  carrierPanel: {
    title: 'परिकलित संख्यात्मक मान',
    material: 'पदार्थ',
    hint: 'ध्यान दें कि {formula} बनाए रखा जाता है (द्रव्यमान क्रिया नियम) चाहे डोपिंग कुछ भी हो, जब तक अर्धचालक गैर-अपक्षयी रहता है (E_F बैंड किनारों से कम से कम 3kT दूर)।'
  },
  common: {
    back: 'वापस',
    next: 'अगला',
    previous: 'पिछला',
    close: 'बंद करें',
    loading: 'लोड हो रहा है...',
    error: 'त्रुटि',
    search: 'खोजें',
    more: 'अधिक',
    less: 'कम',
    showMore: 'अधिक दिखाएं',
    showLess: 'कम दिखाएं',
    goTo: 'जाएं'
  },
  graphs: {
    title: 'ग्राफ',
    details: 'विवरण',
    formula: 'सूत्र',
    description: 'विवरण',
    concepts: 'अवधारणाएं',
    symbols: 'प्रतीक',
    symbol: 'प्रतीक',
    showDetails: 'विवरण दिखाएं',
    hideDetails: 'विवरण छिपाएं',
    replayAnimation: 'एनिमेशन पुनः चलाएं',
    PhotonEnergyGraph: 'फोटॉन ऊर्जा',
    HeisenbergUncertaintyGraph: 'हाइज़नबर्ग अनिश्चितता',
    DensityOfStatesGraph: 'स्थितियों की घनत्व',
    BandStructureGraph: 'बैंड संरचना'
  },
  learningObjectives: {
    title: 'अध्ययन रोडमैप — विकसित करने के लिए 8 दक्षताएँ',
    intro: 'इस सिस्टम का अन्वेषण करने के बाद, आपको नीचे दिए गए प्रत्येक बिंदु पर चर्चा करने में सक्षम होना चाहिए। प्रत्येक अवधारणा को प्रदर्शित करने वाले टैब पर सीधे जाने के लिए बटन का उपयोग करें।',
    selfAssessment: 'स्व-मूल्यांकन:',
    selfAssessmentBody: 'टैब से परामर्श करने से पहले प्रत्येक बिंदु के लिए 2-3 वाक्यों का उत्तर ज़ोर से तैयार करने का प्रयास करें। यदि आप सभी को समझा सकते हैं, तो आपने अर्धचालकों में बैंड सिद्धांत की मूल बातों में महारत हासिल कर ली है।',
    items: {
      q1: {
        title: 'अनुमत और निषिद्ध बैंडों पर गुणात्मक और कठोर रूप से चर्चा (क्रोनिग-पेनी)',
        hints: [
          'गुणात्मक: "परमाणु → बैंड" पैनल में परमाणुओं को पास लाएँ और देखें कि कैसे स्तर विभाजित होते हैं।',
          'कठोर: "क्रोनिग-पेनी" टैब में P बदलें और समीकरण P·sin(αa)/(αa) + cos(αa) = cos(ka) को |LHS| ≤ 1 पर बैंड उत्पन्न करते हुए देखें।',
          '"अनुमत/निषिद्ध बैंड" में कोर बैंड, VB, गैप और CB के साथ पूर्ण क्रिस्टल संरचना देखें।'
        ]
      },
      q2: {
        title: 'सिलिकॉन में ऊर्जा स्तरों के विभाजन पर चर्चा',
        hints: [
          'स्लाइडर r को 1 (पृथक परमाणु) से 0 (क्रिस्टल) तक ले जाएँ। 3s और 3p स्तर पहले विभाजित होते हैं।',
          'N बढ़ाएँ ताकि देख सकें कि 10²³ परमाणुओं के साथ विभाजन व्यावहारिक रूप से सतत है।',
          'गैप E_g ≈ 1.12 eV 3s से उत्पन्न बैंड के शीर्ष और 3p से उत्पन्न CB के आधार के बीच उभरता है।'
        ]
      },
      q3: {
        title: 'E×k आरेख से प्रभावी द्रव्यमान को परिभाषित करें और गति के लिए इसका अर्थ',
        hints: [
          '1/m* = (1/ℏ²)(d²E/dk²): चरम पर बैंड की वक्रता का व्युत्क्रम।',
          '"प्रभावी द्रव्यमान" में बल F लगाएँ और मुक्त कण (m₀) एवं क्रिस्टल कण (m*) को अलग-अलग त्वरित होते देखें।',
          '"k-स्पेस" में Si और GaAs के बीच बदलें: GaAs में m*_n = 0.067 m₀ → बहुत "हल्के" और तेज़ इलेक्ट्रॉन।'
        ]
      },
      q4: {
        title: 'होल (hole) की अवधारणा पर चर्चा',
        hints: [
          '"इलेक्ट्रॉन × होल" में: आवेश +q, प्रभावी द्रव्यमान m*_p > 0, VB के शीर्ष पर रहता है।',
          'होल F = m*_p · a का पालन करता है आवेश +q के साथ क्योंकि द्रव्यमान m*_p = −ℏ²/(d²E/dk²) द्वारा परिभाषित है जहाँ VB के शीर्ष पर d²E/dk² < 0 है।',
          'p-प्रकार "क्रिस्टल जाली" में, बोरॉन Si की जगह लेते समय बंधन में इलेक्ट्रॉन की कमी वाली रिक्त अवस्था देखें।'
        ]
      },
      q5: {
        title: 'प्रत्यक्ष बनाम अप्रत्यक्ष गैप की विशेषताओं पर चर्चा',
        hints: [
          '"k-स्पेस" में सामग्री बदलें:',
          '• GaAs (प्रत्यक्ष गैप, Γ): CB न्यूनतम और VB अधिकतम समान k पर। केवल फोटॉन द्वारा विकिरण संक्रमण → LED और लेज़र के लिए अच्छा।',
          '• Si/Ge (अप्रत्यक्ष गैप): CB न्यूनतम k में स्थानांतरित। संक्रमण के लिए फोटॉन + फोनोन की आवश्यकता → अकुशल प्रकाश उत्सर्जन।'
        ]
      },
      q6: {
        title: 'ऊर्जा बैंड द्वारा धातु × कुचालक × अर्धचालक में अंतर',
        hints: [
          '"धातु × कुचालक × अर्धचालक" में:',
          '• धातु: E_F एक अनुमत बैंड के अंदर → रिक्त अवस्थाएँ तुरंत सुलभ।',
          '• अर्धचालक: छोटा गैप (~1 eV), σ तापमान T के साथ बढ़ता है (थर्मल उत्तेजना वाहक उत्पन्न करती है)।',
          '• कुचालक: बड़ा गैप (>5 eV), 300 K पर भी σ नगण्य।'
        ]
      },
      q7: {
        title: 'अवस्था घनत्व फ़ंक्शन g(E) को परिभाषित और गणना करें',
        hints: [
          'मॉडल: 3D अनंत कूप ⇒ E = ℏ²π²(n_x²+n_y²+n_z²)/(2mL²)।',
          '"अवस्थाओं का घनत्व" में QuantumWell3D पैनल k-स्पेस में अवस्थाओं को असतत बिंदुओं के रूप में दिखाता है; फर्मी गोले की त्रिज्या बढ़ाएँ और असतत गणना की सतत भविष्यवाणी से तुलना करें।',
          'परिणाम: CB के लिए g(E) = (1/2π²)(2m*/ℏ²)^(3/2) √(E−E_c)।'
        ]
      },
      q8: {
        title: 'फर्मी-डिराक वितरण और फर्मी ऊर्जा को समझें',
        hints: [
          'f(E) = 1 / [1 + exp((E−E_F)/k_BT)] E ऊर्जा की एक अवस्था के अधिभोग की प्रायिकता देता है।',
          'T = 0 K पर: f E_F पर एक पूर्ण चरण है। T > 0 पर: ~ k_BT चौड़ाई का सहज संक्रमण।',
          'E_F इलेक्ट्रॉनों का रासायनिक विभव है। धातु में यह बैंड के भीतर है; आंतरिक अर्धचालक में यह मध्य-गैप के पास है।',
          '|E − E_F| ≫ k_BT के लिए, f(E) ≈ exp(−(E−E_F)/k_BT) — मैक्सवेल-बोल्ट्ज़मैन सीमा।'
        ]
      }
    }
  },
  questions: {
    title: '❓ प्रश्न — स्व-मूल्यांकन',
    modeOne: '📇 एक-एक करके',
    modeAll: '📋 सभी',
    stats: {
      pending: 'लंबित',
      reset: '♻️ रीसेट',
      resetTitle: 'सब कुछ रीसेट करें'
    },
    progress: 'प्रश्न {current} / {total}',
    nav: {
      previous: '← पिछला',
      next: 'अगला →'
    },
    card: {
      prompt1: '1. अपने उत्तर को मानसिक रूप से 30 सेकंड में तैयार करने का प्रयास करें।',
      prompt2: '2. मुख्य बिंदुओं की सूची बनाएँ जिन्हें आप शामिल करेंगे।',
      prompt3: '3. तैयार होने पर, जाँचने के लिए नीचे क्लिक करें।',
      show: '👁️ उत्तर दिखाएँ',
      hide: '🔁 छिपाएँ',
      modelAnswer: 'मॉडल उत्तर:',
      keyPoints: 'मुख्य बिंदु:',
      demos: 'प्रदर्शन:',
      score: 'आपका प्रदर्शन कैसा रहा?',
      scoreOk: '✅ सही',
      scoreNo: '❌ ग़लत / आंशिक'
    },
    usage: {
      title: 'कैसे उपयोग करें:',
      body: 'प्रकट करने से पहले उत्तर तैयार करने का प्रयास करें। कमज़ोर बिंदुओं की पहचान के लिए स्व-मूल्यांकन का उपयोग करें। टैब में अवधारणा की समीक्षा करें'
    }
  },
  about: {
    title: '👤 परिचय',
    tabs: {
      author: '👤 लेखक',
      bibliography: '📚 ग्रंथसूची'
    },
    section: {
      about: 'परियोजना के बारे में',
      author: 'लेखक',
      contribute: 'योगदान दें — Pull Request के माध्यम से आलोचना और सुझाव',
      repository: 'रिपॉज़िटरी',
      network: 'साइट नेटवर्क'
    },
    project: {
      p1body: 'इस परियोजना का उद्देश्य अर्धचालक भौतिकी सीखने को सुगम बनाना है और यह मेरी अपनी पढ़ाई की प्रगति के साथ लगातार विस्तारित होती रहेगी। इसे Claude Opus 4.7 को पेयर-प्रोग्रामिंग पार्टनर के रूप में और छोटे समायोजनों के लिए SWE-1.6 का उपयोग करके बनाया गया है, जो Donald A. Neamen की पुस्तक Semiconductor Physics and Devices के मेरे पठन पर आधारित है, और Modular Series on Solid State Devices (Robert F. Pierret et al.) द्वारा पूरक है।',
      p2body: 'यह एक गैर-लाभकारी परियोजना है जो Basicão da Eletrônica की साइटों के नेटवर्क का हिस्सा है, जो इलेक्ट्रॉनिक्स ज्ञान को सुलभ और निःशुल्क तरीके से प्रसारित करने के लिए समर्पित है।'
    },
    authorInfo: {
      name: 'नाम:',
      website: 'वेबसाइट:',
      email: 'ई-मेल:',
      whatsapp: 'व्हाट्सएप:',
      community: 'व्हाट्सएप समुदाय — अर्धचालक भौतिकी:',
      joinGroup: 'समूह में शामिल हों',
      linkedin: 'लिंक्डइन:',
      github: 'GitHub:',
      twitter: 'X (Twitter):'
    },
    pr: {
      heading: '🎯 मुख्य संदेश:',
      body: 'इस परियोजना की आलोचना, सुझाव, सुधार या संवर्धन का सर्वोत्तम तरीका Pull Request खोलना है। आपका योगदान हमेशा स्वागत योग्य है, चाहे वह किसी स्पष्टीकरण में अल्पविराम हो या नए विज़ुअलाइज़ेशन का पूरा अध्याय। यदि PR जैसी की तैसी स्वीकार नहीं की जाती है, तो भी यह एक मूल्यवान चर्चा खोलती है जो आमतौर पर परियोजना में शामिल होने वाली किसी चीज़ में विकसित होती है।',
      openPR: '🚀 Pull Request खोलें',
      guide: '📖 योगदान गाइड (CONTRIBUTING.md)',
      openIssue: '🐛 Issue खोलें'
    },
    windsurf: {
      heading: '🌊 Windsurf का उपयोग करें — परियोजना पहले से तैयार है',
      p1: 'मैं योगदान के लिए Windsurf संपादक की पुरज़ोर अनुशंसा करता हूँ। परियोजना में .windsurf/rules/ में कोडिंग नियम हैं जिन्हें संपादक स्वचालित रूप से लागू करता है: लॉगिंग पैटर्न (PDCL), markdown स्वरूपण, घटक संरचना — सब कुछ पहले से कॉन्फ़िगर किया गया है। .windsurf/workflows/ में तैयार वर्कफ़्लो (जैसे /pdcl) भी हैं जो सामान्य कार्यों को स्वचालित करते हैं। Cascade एजेंट यहाँ अपनाई गई PDCL पद्धति (Plan, Do, Check, Loop) को समझता है और उस प्रवाह के भीतर नई कार्यान्वयनों का स्वाभाविक रूप से मार्गदर्शन करता है।',
      p2: 'यदि आप VS Code, Cursor या कोई अन्य संपादक पसंद करते हैं, तो सब कुछ काम करता है — बस .windsurf/rules/ में वर्णित नियमों का मैन्युअल रूप से पालन करें।'
    },
    hook: {
      heading: '⚙️ pre-commit Hook — स्वचालित रूप से मानकीकृत दस्तावेज़ीकरण',
      body: 'scripts/markdown_history_manager.py में एक स्वचालित स्क्रिप्ट है, जो .git/hooks/pre-commit द्वारा सक्रिय होती है। .md फ़ाइलों से जुड़े प्रत्येक commit पर, यह लेखक और तारीख का पता लगाती है, और .windsurf/rules/documentacao.md में परिभाषित मानक का पालन करते हुए परिवर्तन इतिहास में एक प्रविष्टि जोड़ती है।',
      useAlways: 'हमेशा उपयोग करें — यह वही है जो दस्तावेज़ीकरण को ट्रेस करने योग्य और मानकीकृत रखता है।'
    },
    biblio: {
      heading: 'अनुशंसित ग्रंथसूची',
      intro: '{count} शीर्षकों के साथ व्यवस्थित सूची। पहले दो इस सिस्टम के निर्माण में उपयोग किए गए मुख्य संदर्भ हैं; शेष बैंड सिद्धांत, उपकरण और ठोस-अवस्था भौतिकी के पूरक हैं। प्रत्येक मद Amazon (खोज या सीधा उत्पाद) से जुड़ी है।',
      mainRefs: '📌 परियोजना के मुख्य संदर्भ',
      supplementary: '📚 पूरक ग्रंथसूची',
      amazonBtn: '🛒 Amazon',
      amazonTitle: 'Amazon पर खरीदें/खोजें',
      note: 'नोट:',
      noteBody: 'कुछ लिंक Amazon Brasil पर उपलब्ध होने पर विशिष्ट उत्पाद पृष्ठ पर ले जाते हैं; अन्य शीर्षक/लेखक द्वारा खोज पर ले जाते हैं, निकटतम उपलब्ध संस्करण लौटाते हैं। पुराने संस्करण आउट-ऑफ़-प्रिंट हो सकते हैं — सेकंड-हैंड बुकशॉप, विश्वविद्यालय पुस्तकालयों और Z-Library, IEEE Xplore तथा Google Books जैसे प्लेटफ़ॉर्म पर भी देखें।'
    }
  },
  glossary: {
    title: '📚 शब्दावली',
    searchPlaceholder: 'शब्द या परिभाषा खोजें...',
    noResults: 'कोई शब्द नहीं मिला',
    categories: {
      all: 'सभी',
      physics: 'भौतिकी',
      materials: 'सामग्री',
      devices: 'उपकरण',
      technology: 'प्रौद्योगिकी'
    }
  },
  support: {
    title: '💖 हमारा समर्थन करें',
    tabs: {
      about: '👤 परिचय',
      donation: '💰 दान'
    },
    about: {
      title: 'परियोजना के बारे में',
      p1: 'यह एक गैर-लाभकारी शैक्षिक पहल है जिसका उद्देश्य अर्धचालक भौतिकी के बारे में ज्ञान को सुलभ और मुफ्त तरीके से प्रसारित करना है।',
      p2: 'इस प्लेटफ़ॉर्म को विकसित और बनाए रखने के लिए समय, संसाधन और समर्पण की आवश्यकता होती है। आपका योगदान परियोजना को सक्रिय रखने और इसकी सामग्री का विस्तार करने में मदद करता है।',
      p3: 'सभी दान होस्टिंग लागत, नई सुविधाओं के विकास और सिस्टम की निरंतर सुधार को कवर करने के लिए उपयोग किए जाते हैं।',
      highlight: 'साथ में, हम भौतिकी और इंजीनियरिंग की शिक्षा को सभी के लिए अधिक सुलभ बना सकते हैं!',
      howToHelp: 'आप कैसे मदद कर सकते हैं:',
      codeContribution: 'GitHub पर Pull Requests के माध्यम से कोड में योगदान दें',
      documentation: 'दस्तावेज़ीकरण और अनुवाद में सुधार करें',
      translation: 'सामग्री का अन्य भाषाओं में अनुवाद करें',
      reporting: 'बग की रिपोर्ट करें और सुधार सुझाएं',
      financial: 'परियोजना का समर्थन करने के लिए वित्तीय दान करें'
    },
    donation: {
      title: 'दान करें',
      intro: 'अपनी पसंद की योगदान विधि चुनें। कोई भी राशि स्वागत है और अंतर लाती है!',
      pixScan: 'QR कोड स्कैन करें',
      pixKey: 'PIX कुंजी',
      pixNote: 'ऊपर दी गई कुंजी का उपयोग करें या अपने बैंकिंग ऐप के साथ QR कोड स्कैन करें',
      crypto: 'क्रिप्टोकरेंसी',
      copy: 'कॉपी करें',
      viewExplorer: 'एक्सप्लोरर पर देखें',
      disclaimer: 'महत्वपूर्ण सूचना',
      disclaimerText: 'दान स्वैच्छिक और गैर-वापसी योग्य हैं। दान करके, आप एक गैर-लाभकारी शैक्षिक परियोजना का समर्थन कर रहे हैं। प्रश्न होने पर संपर्क करें।'
    },
    wallet: {
      title: 'वॉलेट के माध्यम से दान करें',
      connectDescription: 'सीधे दान करने के लिए अपनी क्रिप्टो वॉलेट (MetaMask, WalletConnect, आदि) कनेक्ट करें।',
      connecting: 'कनेक्ट हो रहा है...',
      connectButton: '🦊 MetaMask कनेक्ट करें',
      wallet: 'वॉलेट',
      network: 'नेटवर्क',
      ethereumMainnet: 'Ethereum Mainnet',
      sepoliaTestnet: 'Sepolia Testnet',
      chainId: 'Chain ID',
      switchNetwork: 'Ethereum Mainnet पर स्विच करें',
      crypto: 'क्रिप्टोकरेंसी',
      addressOnly: 'केवल पता',
      amount: 'राशि',
      suggestedAmounts: 'सुझाई गई राशियाँ',
      donateButton: '💖 अभी दान करें',
      processing: 'प्रोसेसिंग...',
      transactionSent: 'लेनदेन भेजा गया',
      addressDescription: '{{crypto}} दान के लिए, नीचे दिए गए पते का उपयोग करें:',
      disconnect: 'डिस्कनेक्ट करें',
      copy: 'कॉपी करें'
    }
  }
};
